<template>
    <div class="top-nav">
        <div @click="() => router.push('/')" class="top-nav__logo">
            <img src="@\assets\logo.svg" alt="">
            <h3>Campus</h3>
        </div>
        <div class="top-nav__user">
            <i class="material-icons">help</i>
            <div title="Perfil" class="container-user" @click="openUserMenu()">
                <img v-if="user.picture" :src="getFile(user.picture,'user')">
                <img v-else src="@\assets\user.png" alt="">
            </div>
        </div>


        <div class="top-nav__options-user" v-if="optionsUser">
            <strong>{{user.Nombre}} {{user.Apellido}}</strong>
            <hr>
            <button @click="optionsUser = false; modalChangePassword = true">
                <i class="material-icons-outlined">lock</i>
                Cambiar contraseña
            </button>
            <button @click="logout">
                <i class="material-icons-outlined">logout</i>
                Cerrar sesión
            </button>
        </div>


        <Modal v-if="modalChangePassword" :isOpen="modalChangePassword" @close="modalChangePassword = false">
            <div class="modal__email">
                <template v-if="formActive">    
                    <h3>Modificar contraseña</h3>
                    <span>Recuerda que la nueva contraseña debe cumplir los siguientes requisitos:</span>

                    <ul>
                        <li>6 o más caracteres</li>
                        <li>Al menos 1 número</li>
                        <li>Al menos 1 mayúscula</li>
                    </ul>

                    <div class="modal__email__form">
                        <div class="password_container">
                            <input :type="passwordType" placeholder="Contraseña Actual" v-model="passwordModel.currentPassword" :class="{'input-invalid': (v$.passwordModel.currentPassword.$invalid && submitted && invalidOldPassword)}">
                            <i v-if="passwordType == 'password'" class="material-icons" @click.stop="passwordType = 'text'">visibility</i>
                            <i v-else class="material-icons" @click.stop="passwordType = 'password'">visibility_off</i>
                        </div>

                        <div class="password_container">
                            <input :type="passwordType" @input="validatePassword(passwordModel.password)" placeholder="Nueva contraseña" v-model="passwordModel.password" :class="{'input-invalid': (v$.passwordModel.password.$invalid && (submitted || invalidPassword))}">
                            <i v-if="passwordType == 'password'" class="material-icons" @click.stop="passwordType = 'text'">visibility</i>
                            <i v-else class="material-icons" @click.stop="passwordType = 'password'">visibility_off</i>
                        </div>

                        <div class="login-error" v-if="invalidPassword && !v$.passwordModel.password.required.$invalid"><i class='material-icons'>error_outline</i>La contraseña no cumple los requisitos</div>

                        <div class="password_container">
                            <input :type="passwordType" placeholder="Confirmar contraseña" v-model="passwordModel.confirmPassword" :class="{'input-invalid': (v$.passwordModel.confirmPassword.$invalid && submitted)}">
                            <i v-if="passwordType == 'password'" class="material-icons" @click.stop="passwordType = 'text'">visibility</i>
                            <i v-else class="material-icons" @click.stop="passwordType = 'password'">visibility_off</i>
                        </div>
                    </div>

                    <div class="buttons">
                        <button class="next" @click="sendChangePassword" :disabled="submitted">{{ submitted  ? $t('login.actions.PROCESSING') :'Confirmar' }} <i class="material-icons">east</i></button>
                    </div>
                </template>
                <template v-else>
                    <div class="modal__email__confirm">
                        <i class="material-icons">error_outline</i>
                        <div>
                            <h4>Tu contraseña fue generada con éxito</h4>
                            <p>Podrás ingresar con tu nueva contraseña la próxima vez que inicies sesión</p>
                        </div>
                        <div class="buttons">
                            <button class="next" @click="modalChangePassword = false">Aceptar</button>
                        </div>
                    </div>
                </template>
            </div>
        </Modal>
    </div>   
</template>

<script>
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { computed, inject, ref } from 'vue';
import Modal from '@/components/Modal.vue';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';

export default {
    components: {
        Modal
    },
    setup() {
        const v$ = useVuelidate();
        const route = useRoute();
        const router = useRouter();
        const store = useStore();
        const getFile = inject("getFile");
        const user = computed(() => store.getters.manageUser_user);
        const logoText = ref('Comunidad de Educadores');
        const optionsUser = ref(false);

        // Modal
        const modalChangePassword = ref(false);
        const passwordType = ref('password');
        const invalidPassword = ref(false);
        const formActive = ref(true);
        const invalidOldPassword = ref(false)
        const passwordModel = ref({
            currentPassword: '',
            password: '',
            confirmPassword: ''
        })
        const submitted = ref(false);

        function openUserMenu() {
            optionsUser.value = !optionsUser.value;
        }

        // function openHelpMenu(){
        //     emit('openHelpMenu');
        // }

        function validatePassword(password) {
            let validPassword = new RegExp(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])([a-zA-Z0-9]{6,32})$/); //eslint-disable-line
            validPassword.test(password) ? invalidPassword.value = false : invalidPassword.value = true;
            console.log(invalidPassword.value)
            return false;
        }

        async function logout(){
            await store.dispatch("manageUser_disabled");
            router.push("/login");
        }

        async function sendChangePassword() {
            submitted.value = true;
            if (!v$.value.passwordModel.$invalid) {
                try {
                    await store.dispatch('inscription_changePassword', { oldPassword : passwordModel.value.currentPassword, newPassword : passwordModel.value.password } );
                    formActive.value = false;
                    submitted.value = false;
                    invalidOldPassword.value = false
                } catch (error) {
                    console.log(error);
                    if(error.response.data != null && error.response.data.Message == 'INVALID_OLD_PASSWORD')
                    {
                        store.dispatch('notifications_create', { text: 'Contraseña anterior incorrecta' })
                        invalidOldPassword.value = true
                    }
                    else
                    {
                        store.dispatch('notifications_create', { text: 'Ocurrió un error, intenta nuevamente' })
                    }
                    
                    submitted.value = false;
                }
            }
        }

        // onMounted(()=>{
        //     if(location.href.includes('changeColors') || location.href.includes('learning.fundacionforge.org')){
        //         logoText.value = 'Learning Community';
        //     }
        // })

        return {
            openUserMenu,
            route,
            getFile,
            user,
            router,
            logoText,
            optionsUser,
            passwordType,
            passwordModel,
            v$,
            validatePassword,
            invalidPassword,
            modalChangePassword,
            formActive,
            sendChangePassword,
            submitted,
            logout,
            invalidOldPassword
        }

    },
    validations(){
        return{
            passwordModel: {
                currentPassword: { required },
                password: { required },
                confirmPassword: { required }
            }
        }
    }
    
}
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';
.top-nav{
    height: 56px;
    position: sticky;
    top: 0;
    z-index: 2000;
    padding: 0 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    color: #7d7d7d;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);

    @media screen and (max-width: 1024px){
        & {
            position: unset;
        }
    }

    &__logo{
        display: flex;
        align-items: flex-end;
        color: #7d7d7d;
        gap: 24px;
        cursor: pointer;

        img{
            width: 46px;            
        }

        h3{
            //font-size: 21px;
            padding-bottom: 2px;
            color: $black;
        }
    }
    &__menu{
        display: flex;
        width: fit-content;
        gap: 32px;
        a{
            display: inline-flex;
            align-items: center;
            gap: 4px;
            color: $black;
            text-decoration: none;
            &:last-child{
                gap: 1px;
            }
            &:hover, &.active{
                color: $green;
            }
            span{
                font-style: normal;
                font-weight: 600;
                font-size: 14px;
            }
        }
    }
    &__user{
        width: fit-content;
        padding-right: 8px;
        display: flex;
        align-items: center;
        gap: 12px;

        .material-icons {
            color: $green;
            cursor: pointer;
            &:nth-child(2){
                cursor: default;
            }
        }

        .container-search {
            position: relative;
            width: 100%;
            display: flex;
            align-items: center;
            
            i {
                position: absolute;
                right: 0;
                padding-right: 12px;
                font-size: 24px;
                cursor: pointer;
                color: #7d7d7d;
            }

            input {
                background: #f6f6f6;
                border: none;
                padding: 8px 12px;
                max-width: 300px;
                width: 100%;
                border-radius: 12px;
                color: #7d7d7d;
            
                &::placeholder {
                    color: #7d7d7d;
                }
            }

        }

        .pipe {
            border: 1px solid #e0e0e0;
            border-radius: 12px;
            margin: 0 24px;
            height: 32px;
        }

        .container-user {
            position: relative;
            width: 38px;
            height: 38px;
            flex-shrink: 0;
            border-radius: 100%;
            overflow: hidden;
            img{
                width: 100%;
                height: 100%;
                object-fit: cover;
                cursor: pointer;
            }
        }
    }

    &__options-user {
        position: absolute;
        top: 56px;
        right: 8px;
        padding: 12px 0px;
        display: flex;
        flex-direction: column;
        gap: 4px;
        background: white;
        box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.2);

        strong {
            color: $green;
            text-align: center;
            margin-bottom: 4px;
        }

        button {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            padding: 8px 16px;
            gap: 8px;
        }

    }
}


.modal__email {
    padding: 12px 24px;
    color: black;
    display: flex;
    flex-direction: column;
    gap: 12px;

    ul {
        margin-left: 40px;
 
        li{
            list-style: circle;
        }
    } 

    &__form {
        display: flex;
        flex-direction: column;
        gap: 12px; 
    
        .password_container{
        position: relative;
        width: 100%;
        height: fit-content;
        
        .material-icons {
            position: absolute;
            right: 0;
            top: 20%;
            padding-right: 12px;
            font-size: 24px;
            cursor: pointer;
            color: $black;
        }
        }
        
        input {
            height: 42px;
            width: 100%;
            padding: 12px 22px;
            margin-bottom: 8px;
            background: #f6f6f6;
            border: none;
            border-radius: 26px;
            color: #7d7d7d;
        
            &::placeholder {
            color: #7d7d7d;
            }
        
            &.input-invalid{
            color: $login-error-color;
            border: 1px solid $login-error-color;
            }
            &.input-invalid::placeholder {
            color: $login-error-color;
            }
        }
    }
    .buttons {
        display: flex;
        justify-content: space-around;
        margin-bottom: 24px;
    
        .back{
            width: 100%;
            padding: 13px 0;
            @include icon-and-text-container;
            justify-content: center;
            background: #fff;
            border: 1px solid;
            border-radius: 44px;
            color: $green;
            font-weight: 600;
            font-size: 16px;
            .material-icons{
                font-size: 18px;
            }
        }
    
        .next{
            width: 100%;
            padding: 13px 0;
            @include icon-and-text-container;
            justify-content: center;
            background: $green;
            border-radius: 44px;
            color: #fff;
            font-weight: 600;
            font-size: 16px;
            .material-icons{
                font-size: 18px;
            }
        }
    }

    &__confirm {
        display: flex;
        flex-direction: column;
        gap: 24px;
        text-align: center;

        i {
            color: $green;
        }
    }
}

</style>